import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import validade from "./validate";
const useFetchData = (endpoint) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        
         validade(localStorage.getItem("accessToken"));
         const token = localStorage.getItem("accessToken");
        if (!token) {
          throw new Error("Token inválido ou expirado.");
        }

        const response = await fetch(`https://getapi.lc-transportes.com/${endpoint}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Erro: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchData();
  }, [endpoint, location]);

  return { data, error };
};

export default useFetchData;
